<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Add to Balance
      </content-page-title>
    </template>

    <Section>

      <v-form ref="form" v-model="isValid">
        <div>
          If you don't have any payment methods, You can add one by
          going back to the previous page and tapping the "+" next to
          Payment Methods.
        </div>
        
        <PaymentMethodSelect
          dense outlined hide-details="auto"
          class="mt-6"
          label="Choose a Payment Method"
          v-model="payment_method"
          :rules="[required]"
        />

        <div class="d-flex">
          <vuetify-money
            dense outlined hide-details="auto"
            placeholder="50.00"
            label="Enter Amount"
            v-model="amount"
            @SetValueMax="(maxVal) => amount = maxVal"
            :rules="[required, gte_12]"
            :options="currencyOptions"
            :valueOptions="valueOptions"
            class="mt-4"
            style="max-width: 100px"
          />

          <div class="grey--text ml-4 mt-4" style="line-height: 1.2; font-size: 12px;">
            A non-refundible 2.9% + $0.30 service fee will be included.
          </div>
        </div>

        <v-divider class="mt-4"></v-divider>

        <div class="d-flex justify-center pt-4 pb-2">
          <v-btn @click="close">Cancel</v-btn>
          <ConfirmDialog 
            class="ml-3" 
            :disabled="!isValid"
            :amount="amount*100"
            @confirm="onSubmit"
          />
        </div>
      </v-form>
    </Section>
    <ErrorOverlay
      title="Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </ContentPage>
</template>

<script>

import ConfirmDialog from './ConfirmDialog'
import { ContentPage, ContentPageTitle, Section } from '@/components/pages'
import ErrorOverlay from '@/components/pages/ErrorOverlay'
import { PaymentMethodSelect } from '@/components/inputs'
import { mapActions, mapGetters } from 'vuex'
import formatters from '@/lib/formatters'
import { required } from '@/lib/validations'

export default {
  name: 'AddBalanceView',

  components: { 
    ConfirmDialog, ContentPage, ContentPageTitle, ErrorOverlay, PaymentMethodSelect,
    Section 
  },

  data: () => ({
    payment_method: null,
    amount: 50,
    isValid: true,

    currencyOptions: {
      locale: "en-US",
      prefix: "$ ",
      suffix: "",
      length: 7,
      precision: 2,
    },

    valueOptions: {
      max: 500,
    },

    // validation rules
    required,
    gte_12: v => Number(v) >= 12 || '$12 minimum',

    // error handling
    loading: false,
    error_dialog: false,
    error_message: '',
  }),

  computed: {
    ...mapGetters('auth', ['me']),
  },

  methods: {
    ...mapActions('billing', ['pay']),
    ...formatters,

    close() {
      this.$router.push({ name: 'billing/account' })
    },

    async onSubmit() {
      if (this.$refs.form.validate()) {
        const payload = {
          payment_method: this.payment_method,
          amount_cents: (this.amount * 100).toFixed()
        }
        
        this.loading = true
        const result = await this.pay(payload)
        this.loading = false
        if (result.ok) {
          this.close()
        } else {
          this.error_dialog = true
          this.error_message = "Unable to collect this payment.  Please check your card balance."
        }
      }
    },
  },
}
</script>